import React from 'react';
import PropTypes from 'prop-types';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getTypeArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { TypeArticle } from 'site-modules/editorial/pages/type/article';

function TwoColumnUI({ content = null, type, articleId = null }) {
  if (!content) {
    return null;
  }
  return <TypeArticle content={content} slug={type} articleId={articleId} />;
}

TwoColumnUI.propTypes = {
  type: PropTypes.string.isRequired,
  articleId: PropTypes.string,
  content: CmsEntities.Content,
};

export const TwoColumn = connectToModel(TwoColumnUI, {
  content: bindToContent(({ type, articleId }) => getTypeArticleContentPath(type, articleId)),
});
